export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SummaryResult.vue?vue&type=template&id=e6870b98&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/summary/SummaryResult.vue?vue&type=template&id=e6870b98&scoped=true&
// module id = 1553
// module chunks = 0